export function pageCompressor(pages, index) {
    const { ...clone } = pages[index];
    const { width, height } = pages[0];

    // We just don't use this
    delete clone.chapter;
    if (clone.image === `${clone.pagenum + 1}.png`) {
        delete clone.image;
    }
    if (index > 0 && clone.width === width) {
        delete clone.width;
    }
    if (index > 0 && clone.height === height) {
        delete clone.height;
    }

    return clone;
}

export function pageDecompressor(pages, index) {
    const page = pages[index];
    const { width, height } = pages[0];

    return {
        image: `${page.pagenum + 1}.png`,
        width,
        height,
        ...page,
    };
}



// WEBPACK FOOTER //
// ./src/page_compressor.js